module.exports = __webpack_public_path__ + "media/images/components/c09-person-search-result/placeholder-picture-38ed69015bd118440ed391b123d4702d.svg";